/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_ACCOUNT,
  FETCH_AXA_ACCOUNT,
  FETCH_ACCOUNT_SUCCESS,
  FETCH_ACCOUNT_FAILURE,
  FETCH_ACCOUNT_LIST_FAILURE,
  FETCH_ACCOUNT_LIST_SUCCESS
} from './actionTypes'
import { Account } from './account'

export function fetchAccount() {
  return {
    type: FETCH_ACCOUNT,
  }
}
export function fetchAxaAccount() {
  return {
    type: FETCH_AXA_ACCOUNT,
  }
}
export function fetchAccountSuccess(json) {
  return {
    type: FETCH_ACCOUNT_SUCCESS,
    item: json,
  }
}
export function fetchAccountFailure(error) {
  return {
    type: FETCH_ACCOUNT_FAILURE,
    errorMessage: error.message,
  }
}
export function fetchAccountListSuccess(json) {
  return {
    type: FETCH_ACCOUNT_LIST_SUCCESS,
    accounts: json.sort(sortByProperty('contactName')),
  }
}
export function fetchAccountListFailure(error) {
  return {
    type: FETCH_ACCOUNT_LIST_FAILURE,
    errorMessage: error.message,
  }
}
export function getAccount() {
  return dispatch => {
    dispatch(fetchAccount())
    return Account.getAccounts()
      .then(response => response.data)
      .then(json => dispatch(fetchAccountListSuccess(json)))
      .catch(function(error) {
        dispatch(fetchAccountListFailure(error))
      })
  }
}

function sortByProperty(property){  
  return function(a,b){  
     if(a[property] > b[property])  
        return 1;  
     else if(a[property] < b[property])  
        return -1;   
     return 0;  
  }  
}
